<nz-steps
    [nzCurrent]="currentStep"
    [nzDirection]="direction"
    (nzIndexChange)="clickable ? stepChanged.emit($event) : undefined">
    @for (step of stepArray(); track step) {
        <nz-step
            [nzTitle]="step.titleTemplate ?? step.title"
            [nzDescription]="step.contentTemplate"
            [nzIcon]="step.nzIcon">
        </nz-step>
    }
</nz-steps>
